import React from 'react';

import Context     from '../../../../../../context';
import validations from '../../../../../../validations';

import { useFormik         } from 'formik';
import { useTranslation    } from 'react-i18next';
import { locationNamespace } from '../../../../../../types/location.namespace';

import {
  CustomInput,
  CustomModal,
  CustomButton2,
  CustomLeaflet,
  ResponsiveView, LocationDropdowns,
} from '../../../../../../components';

import './index.sass';

const Update: React.FC = (): React.ReactElement => {

  // # =================================================================================================================
  // # --------------------------------------------- Start Validate Values ---------------------------------------------

  const { showModal, setShowModal, updateFunction, isLoading, selectedNeighborhood } = React.useContext(Context.Location.Neighborhood);
  const [location, setLocation] = React.useState<Array<number | undefined>>([
    selectedNeighborhood?.location?.coordinates[0] || undefined,
    selectedNeighborhood?.location?.coordinates[1] || undefined
  ]);
  const [selectedProvince, setSelectedProvince] = React.useState<locationNamespace.province.index>();
  const [selectedCity    , setSelectedCity    ] = React.useState<locationNamespace.city    .index>();
  const [selectedArea    , setSelectedArea    ] = React.useState<locationNamespace.area    .index>();
  const { t } = useTranslation();

  // # ---------------------------------------------- End Validate Values ----------------------------------------------
  // # =================================================================================================================

  // * =================================================================================================================
  // * -------------------------------------------- Start Local Functions ----------------------------------------------

  const formik = useFormik<locationNamespace.neighborhood.create>({
    enableReinitialize: true,
    initialValues: {
      isCapital: selectedNeighborhood?.isCapital,

      key        : selectedNeighborhood?.key,
      name       : selectedNeighborhood?.name || '',
      prefix     : selectedNeighborhood?.prefix,
      description: selectedNeighborhood?.description,

      code      : selectedNeighborhood?.code,
      population: selectedNeighborhood?.population,

      // location: {
      //   type: 'Point',
      //   coordinates: [NaN, NaN],
      // }
    },
    validationSchema: validations.location.province.create,
    onSubmit: (values: locationNamespace.neighborhood.create, { setSubmitting }) => {
      const newValues: locationNamespace.neighborhood.create = {
        ...values,
        town: selectedArea ? selectedArea?._id : selectedNeighborhood?.town._id,
        // location: {
        //   type: 'Point',
        //   coordinates: [
        //     location[0] ? Number(location[0]) : Number(selectedNeighborhood?.location?.coordinates[0]),
        //     location[1] ? Number(location[1]) : Number(selectedNeighborhood?.location?.coordinates[1]),
        //   ]
        // }
      }
      Promise.resolve(updateFunction!(newValues)).catch((e) => setSubmitting(false));
    },
  });

  async function submitHandler(): Promise<void> {
    await formik.submitForm();
  }

  function handleChangeLocation(lat: any, lng: any): void {
    setLocation([lat, lng]);
  }

  function onSelectProvince(province: locationNamespace.province.index): void {
    if (!province) return;
    setSelectedProvince(province);
    setLocation([
      province?.location?.coordinates[0] || undefined,
      province?.location?.coordinates[1] || undefined,
    ]);
  }

  function onSelectCity(city: locationNamespace.city.index): void {
    if (!city) return;
    setSelectedCity(city);
    setLocation([
      city?.location?.coordinates[0] || undefined,
      city?.location?.coordinates[1] || undefined,
    ]);
  }

  function onSelectArea(area: locationNamespace.area.index): void {
    if (!area) return;
    setSelectedArea(area);
    setLocation([
      area?.location?.coordinates[0] || undefined,
      area?.location?.coordinates[1] || undefined,
    ]);
  }

  // * --------------------------------------------- End Local Functions -----------------------------------------------
  // * =================================================================================================================

  // ? =================================================================================================================
  // ? ----------------------------------------------- Start Return View -----------------------------------------------

  return (
    <section id="parent-update-modal-container">
      <form onSubmit={submitHandler}>
        <CustomModal label='ویرایش محله' open={showModal === 'UPDATE'} onClose={() => setShowModal!('NONE')}>
          <ResponsiveView.Container className="create-form-content">
            <br/>
            <hr/>
            <ResponsiveView.Row className="form-row">
              <ResponsiveView.Column medium={6}>
                <LocationDropdowns.Province
                  onSelectItem = { onSelectProvince }
                  defaultItem  = { selectedProvince ? selectedProvince : selectedNeighborhood?.province }
                />
              </ResponsiveView.Column>
              <ResponsiveView.Column medium={6}>
                <LocationDropdowns.City
                  selectedProvince= { selectedProvince ? selectedProvince : selectedNeighborhood?.province }
                  onSelectItem    = { onSelectCity     }
                  defaultItem     = { selectedCity ? selectedCity : selectedNeighborhood?.city}
                />
              </ResponsiveView.Column>
            </ResponsiveView.Row>
            <ResponsiveView.Row className="form-row">
              <ResponsiveView.Column medium={6}>
                <LocationDropdowns.Area
                  selectedProvince = { selectedProvince ? selectedProvince : selectedNeighborhood?.province }
                  selectedCity     = { selectedCity     ? selectedCity     : selectedNeighborhood?.city     }
                  onSelectItem     = { onSelectArea     }
                  defaultItem      = { selectedArea ? selectedArea : selectedNeighborhood?.town }
                />
              </ResponsiveView.Column>
            </ResponsiveView.Row>
            <hr/>
            <ResponsiveView.Row className="form-row">
              <ResponsiveView.Column medium={6}>
                <CustomInput
                  id='name'
                  name='name'
                  label={'نام محله'}
                  value={formik.values.name}
                  error={formik.errors.name && formik.touched.name}
                  errorText={formik.errors.name}
                  formikProps={{onBlur: formik.handleBlur}}
                  onValueChange={formik.handleChange}
                />
              </ResponsiveView.Column>
              <ResponsiveView.Column medium={6}>
                {/*<CustomCheckbox label='مرگز استان میباشد'/>*/}
              </ResponsiveView.Column>
            </ResponsiveView.Row>
            <br/>
            <ResponsiveView.Row className='form-row'>
              <ResponsiveView.Column small={12}>
                <CustomLeaflet
                  onChangeLatAndLng={handleChangeLocation}
                  defaultLat={location[0] ? location[0] : selectedNeighborhood?.location?.coordinates[0]}
                  defaultLng={location[1] ? location[1] : selectedNeighborhood?.location?.coordinates[1]}
                  defaultLatArea={location[0] ? location[0] : selectedNeighborhood?.location?.coordinates[0]}
                  defaultLngArea={location[1] ? location[1] : selectedNeighborhood?.location?.coordinates[1]}
                />
              </ResponsiveView.Column>
            </ResponsiveView.Row>
            <br />
            <hr/>
            <ResponsiveView.Row className="form-row">
              <ResponsiveView.Column large={6} medium={6} small={12}>
                <CustomButton2
                  isLoading={isLoading}
                  onClick={() => setShowModal!("NONE")}
                  title={t("cancel")}
                  type="danger"
                />
              </ResponsiveView.Column>
              <ResponsiveView.Column large={6} medium={6} small={12}>
                <CustomButton2 isLoading={isLoading} onClick={submitHandler} title={t("submit")}/>
              </ResponsiveView.Column>
            </ResponsiveView.Row>
          </ResponsiveView.Container>
        </CustomModal>
      </form>
    </section>
  );

  // ? ------------------------------------------------ End Return View ------------------------------------------------
  // ? =================================================================================================================

};

export default Update;
